/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Divider, Typography } from "@mui/material";
import PaymentTable from "../../components/CommonComponents/PaymentTable";
import { fetchConnectStripe } from "../../store/reducers/createProfile";
import StyledPayments from "./StyledPayments";
import { updateLoading } from "../../store/reducers/loader";
import { fetchEarnings } from "../../store/reducers/payments";
import noPaymentBreakdown from "../../assets/images/no-payment-breakdown.svg";
import { toTwoDecimalPlaces } from "../../utils/commonFunctions";
import rollbar from "../../rollbarConfig";

const Payments = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.createProfile?.userProfile);
  const [earningData, setEarningData] = useState(null);
  const [paginationData, setPaginationData] = useState({});
  const [count, setCount] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(true);

  const connectStipe = async () => {
    dispatch(updateLoading(true));
    try {
      const res = await dispatch(fetchConnectStripe());
      const { status, message, data } = res?.payload || {};
      if (status) {
        window.location.href = data;
      } else {
        console.error("API error: ", message);
        dispatch(updateLoading(false));
      }
    } catch (err) {
      console.error(err);
      rollbar.error("Error message", err);
      dispatch(updateLoading(false));
    }
  };

  const fetchTotalEarnings = async () => {
    try {
      setLoading(true);
      const res = await dispatch(fetchEarnings());
      const { status, message, data, _meta } = res?.payload || {};
      if (status) {
        setEarningData(data);
        setPaginationData(_meta);
        setLoading(false);
      } else {
        console.error("API error: ", message);
        setLoading(false);
      }
    } catch (err) {
      console.error(err);
      rollbar.error("Error message", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTotalEarnings();
  }, []);

  return (
    <StyledPayments>
      <Box className='payments-container'>
        <Box className='payments-wrap-1'>
          <Box className='earning-wrap'>
            <Typography className='earning-header'>
              Earnings Performance
            </Typography>
            <Box className='current-earning-wrapper'>
              <Box className='current-earning'>
                <Typography className='current-earning-header'>
                  Current Earnings (Kept items)
                </Typography>
                <Typography className='current-earning-value'>{`$${toTwoDecimalPlaces(earningData?.current_earnings) || '0'}`}</Typography>
              </Box>
              <Divider className='earning-divider' />
              <Box className='pending-earning'>
                <Typography className='pending-earning-header'>
                  Pending Earnings (Orders in buyers' closets)
                </Typography>
                <Typography className='pending-earning-value'>{`$${toTwoDecimalPlaces(earningData?.pending_earnings) || '0'}`}</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className='payments-wrap-2'>
          <Box className='payment-card'>
            <Box className='payment-details-head'>
              <Box className='payment-details-head-left'>
                <Box className='payment-edit-wrap'>
                  <Typography className='payment-header'>
                    Payout Details
                  </Typography>
                  <Box
                    className='edit-payment-btn'
                    onClick={() => connectStipe()}
                  >
                    Edit bank details
                  </Box>
                </Box>
                <Typography className='payment-text'>
                  Ensure your bank details are accurate to avoid payout delays.
                </Typography>
              </Box>
            </Box>
            <Box className='payment-details'>
              <Box className='payment-details-part1'>
                <Box className='payment-details-block'>
                  <Typography className='payment-details-header'>
                    Account Holder Name
                  </Typography>
                  <Typography className='payment-details-value'>
                    {userData?.seller_name}
                  </Typography>
                </Box>
                <Box className='payment-details-block'>
                  <Typography className='payment-details-header'>
                    Bank Name
                  </Typography>
                  <Typography className='payment-details-value'>
                    {userData?.stripe_connect_details?.bank_name}
                  </Typography>
                </Box>
                <Box className='payment-details-block'>
                  <Typography className='payment-details-header'>
                    SWIFT Code
                  </Typography>
                  <Typography className='payment-details-value'>
                    {userData?.stripe_connect_details?.bsb_number}
                  </Typography>
                </Box>
                <Box className='payment-details-block'>
                  <Typography className='payment-details-header'>
                    Account Number
                  </Typography>
                  <Typography className='payment-details-value'>
                    {`••••  ••••  ••••  ${userData?.stripe_connect_details?.bank_account_last_four_digit}`}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className='payment-breakdown-wrap'>
        <Typography className='payment-breakdown-header'>
          Payments Breakdown
        </Typography>
        {earningData?.order_breakdown?.length > 0 ? (
          <PaymentTable
            data={earningData?.order_breakdown}
            paginationData={paginationData}
            loading={loading}
            setPageSize={setPageSize}
            count={count}
            pageSize={pageSize}
            setCount={setCount}
          />
        ) : (
          <Box className='no-breakdown-wrap'>
            <Box className='no-breakdown-img-wrap'>
              <img src={noPaymentBreakdown} alt='breakdown-icon' />
            </Box>
            <Box className='no-breakdown-text-wrap'>
              <Typography className='no-breakdown-header'>
                No payments found
              </Typography>
              <Typography className='no-breakdown-text'>
                It looks like there are no payment breakdown in the system yet.
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </StyledPayments>
  );
};

export default Payments;
